import * as Animate from "react-reveal";

const AboutIdeaSection = () => {
  return (
    <section className="bg-white py-16 md:py-20 lg:py-24 px-4">
      <div className="container mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-14 items-start">
          <Animate.Fade bottom>
            <div>
              <p className="flex items-center font-poppins gap-3 text-primary text-sm font-extrabold tracking-widest uppercase mb-6">
                <span className="w-8 h-1 rounded-full bg-secondary inline-block"></span>
                The idea behind Utiva
              </p>
              <h2 className="text-3xl md:text-4xl lg:text-5xl font-poppins leading-tight font-black tracking-[-0.03em] text-primary">
                We are building the bridge between ambition and meaningful work.
              </h2>
            </div>
          </Animate.Fade>

          <Animate.Fade bottom>
            <div>
              <p className="text-gray font-poppins text-base leading-relaxed mb-6">
                Utiva began with a practical belief: people should be able to
                learn relevant skills, prove what they can do and reach
                opportunities beyond the limits of where they live.
              </p>
              <p className="text-gray font-poppins text-base leading-relaxed mb-8">
                That belief has grown into an end-to-end platform. Individuals
                can learn through projects, expert guidance and career
                preparation. Companies can access a broad talent community and
                the support required to hire and operate globally.
              </p>

              <div
                className="rounded-2xl p-7"
                style={{ background: "#fdf2df" }}
              >
                <span
                  className="text-secondary font-poppins text-3xl font-black leading-none block mb-3"
                  aria-hidden="true"
                >
                  &ldquo;
                </span>
                <p className="text-primary font-poppins text-xl font-extrabold leading-snug m-0">
                  We do not see talent as anonymous profiles. We see capable
                  people who need the right evidence, support and opportunity.
                </p>
              </div>
            </div>
          </Animate.Fade>
        </div>
      </div>
    </section>
  );
};

export default AboutIdeaSection;
